import { render, staticRenderFns } from "./SowTypeTable.vue?vue&type=template&id=6bd651bc"
import script from "./SowTypeTable.vue?vue&type=script&lang=js"
export * from "./SowTypeTable.vue?vue&type=script&lang=js"
import style0 from "./SowTypeTable.vue?vue&type=style&index=0&id=6bd651bc&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports